import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common';
import React, { useState } from 'react';
import { useOpenArticleByEditorHost } from '../../hooks/use-open-article-by-editor-host';
import { EditorHost } from '../../providers';
export const UnsupportedItemTypeSectionHelper = () => {
  const {
    t
  } = useTranslation();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    prefixIcon: /*#__PURE__*/React.createElement(StatusAlertSmall, null),
    showCloseButton: true,
    showPrefixIcon: true,
    size: "small",
    onClose: () => setIsVisible(false)
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "small",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: () => openSelectedArticle(EditorHost.odeditor, 'editor-package-accessibility-wizard.articles-checklist-for-improving-sites-accessibility')
      })
    },
    i18nKey: "accessibility-wizard.welcome-screen.unsupported-item-type.section-helper",
    t: t
  }))));
};
//# sourceMappingURL=unsupported-item-type-section-helper.js.map